import styled from 'styled-components';

export const EditViewContainer = styled.div`
  .topical-preview {
    padding-left: 195px;
  }
  .question-cart-content {
    margin-top: 60px !important;
    border-bottom: 1px solid rgba(#707070, 0.21);
  }
  .content__stepper-block {
    width: ${props =>
      props.activeStep === 3 ? 'calc(100vw - 395px)' : 'calc(100vw - 195px)'};
    margin-left: 195px;
  }
  .question-cart-content__back {
    margin-top: 0;
    position: absolute;
    left: 1.5rem;
  }
  @media (max-width: 1024px) {
    .content__stepper-block {
      width: 100vw;
      margin-left: 0;
    }
  }

  @media (max-width: 640px) {
    .content__stepper-block {
      width: calc(100vw + 20px);
      left: -20px;
    }
  }
`;
